import styles from './InHouseSupport.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  subTitle: string
  list: {
    text: string
  }[]
}

const InHouseSupport: React.FC<Props> = ({ list, subTitle }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  const InHouseSupportList = list.map((item, index) => (
    <p key={index} className={styles.inhouse__inner__text__item}>
      {item.text}
    </p>
  ))

  return (
    <section
      className={`${styles.inhouse} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.inhouse__inner}>
        <h2 className={styles.sectionTitle}>{subTitle}</h2>
        <div className={styles.inhouse__inner__text}>{InHouseSupportList}</div>
      </div>
    </section>
  )
}

export default InHouseSupport
